/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PartyConfigurationFault } from "./PartyConfigurationFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "DOMAIN_UNKNOWN" = "DOMAIN_UNKNOWN"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment
 */

// required attributes
const PartyConfigurationFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: PartyConfigurationFault
});

// optional attributes
const PartyConfigurationFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const PartyConfigurationFaultPaymentProblemJson = t.intersection(
  [
    PartyConfigurationFaultPaymentProblemJsonR,
    PartyConfigurationFaultPaymentProblemJsonO
  ],
  "PartyConfigurationFaultPaymentProblemJson"
);

export type PartyConfigurationFaultPaymentProblemJson = t.TypeOf<
  typeof PartyConfigurationFaultPaymentProblemJson
>;
